module.exports = __webpack_public_path__ + "media/images/front/img_movie_feature02-29b153d269c3fb6118c9bfee8a64da91.jpg";